import React, {Component} from 'react';
import {Checkbox, Input} from "antd";
import "./VideoGallery.scss"
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../../base/BaseComponent";
import moment from "moment";

const {Search} = Input;
const seekSpider = {
    // 搜索配置项
    findVideoKey: 'findVideoFtitle',//视频保存标题key
    findVideoPlaceholder: '请输入视频搜索内容',//视频的提示
};
export default class VideoGallery extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            seekSpiderInformation: {
                findVideo: '',//输入搜索内容
            },
            videoList: [],
            url: {
                getPersonOrDeptUrl: "/search-server/search/getList/video/personOrDept",//本地上传视频
                getPersonUrl: "/search-server/search/getList/video/person",//我的视频资源库
            },
            params: {
                "pageNum": 1,
                "pageSize": 9999,
                "keyword": ""
            },//视频库查询字段
            checkedList: [],// 多个视频
            total: 0,
            onlyMyVideo: false,
        };
    }

    componentDidMount() {
        this.getZykVideoList()
    }

    render() {
        const {seekSpiderInformation, videoList,total,checkedList} = this.state;

        return (
            <div className="videoGallery">
                <div className="videoFreeNude">
                    <Search
                        className="videoSearchInput"
                        allowClear={true}
                        placeholder={seekSpider.findVideoPlaceholder}
                        onSearch={(value) => {
                            this.videoOnsearch(value)
                        }}
                        onChange={(e) => {
                            this.setData('findVideo', e.target.value)
                        }}
                        value={seekSpiderInformation.findVideo}
                    />
                    <div onClick={() => {
                        this.checkInfor()
                    }}>
                        {/*验证*/}
                    </div>
                    <div onClick={() => {
                        this.setInformation({
                            findVideoFtitle: '作者',
                        })
                    }}>
                        {/*设置内容*/}
                    </div>
                    <div className="videoResource">
                        <Checkbox onChange={(e) => {
                            this.state.onlyMyPics = e.target.checked;
                            this.getZykVideoList()
                        }}>仅我的资源</Checkbox>
                        <div className="videoRecord">
                            共<span style={{color: '#0050B3'}}> {total} </span>条记录
                        </div>
                        <div>已选(<span style={{color: '#0050B3'}}> {checkedList.length} </span>)</div>
                    </div>
                </div>
                    <Scrollbars autoHeight autoHeightMax={'350px'}>
                        <div className="videoOutermost" style={{width: '950px'}}>
                            {
                                videoList && videoList.map((item, index) => {
                                    return (
                                        <div className="videoFromStream" style={{borderColor: item.checked ? '#0050B3' : ""}}
                                             key={item.id} onClick={() => {
                                            this.videoAll(item)
                                        }}>
                                            <video src={item.path} className="repository"></video>
                                            <div className="videoRightWords">
                                                <div className="videoHeadline">{item.name}</div>
                                                <div className="videoUploadData">
                                                    <div>来源：{item.source}</div>
                                                    <div>日期：{moment(item.createTime).format('yyyy-MM-DD HH:mm:ss')}</div>
                                                    <div>时长：{moment(item.duration).format('mm分ss秒')}</div>
                                                </div>
                                                <div className="videoPreview">
                                                    <div>预览</div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Scrollbars>
            </div>
        )
    }
    //
    //获取部门图片库
    getZykVideoList = (value) => {
        let params = {
            ...this.state.params,
            keyword: value,
        };
        let config = this.state.onlyMyPics ? 'getPersonUrl' : 'getPersonOrDeptUrl';
        let url = this.state.url[config];
        this.request({
            url,
            body: params,
            method: "post",
            contentType: 'json',
            callBack: (res) => {
                let videoList = [];
                let total = 0;
                if (res && res.data) {
                    videoList = res.data;
                    total = res.count;
                }
                this.setState({videoList, total});
                console.log(res)
            }
        })
    };
    // 搜索
    videoOnsearch=(value)=>{
        this.getZykVideoList(value);
    };
    // 选择多视频上传
    videoAll = (zykVideo) => {
        let {videoList} = this.state;
        let index = videoList.findIndex(item => item.id == zykVideo.id);
        videoList[index].checked = !zykVideo.checked;
        this.setState({});
        if (typeof this.props.onChange == 'function') {
            let checkedList = videoList.filter(item => item.checked);
            this.setState({checkedList})
        }
        this.props.onChange(this.state.checkedList);
    };

    //输入框改变复制
    setData(key, val) {
        // console.log(key, val);
        this.state.seekSpiderInformation[key] = val;
        this.setState({
            params: {
                ...this.state.params,
                keyword: val
            }
        });
        if (!val) {
            this.getZykVideoList(val)
        }
    }

    //获取信息
    getInformation() {
        let seekSpiderData = {};
        const {seekSpiderInformation} = this.state;
        seekSpiderData[seekSpider.findVideoKey] = seekSpiderInformation.findVideo;//获取视频
        return seekSpiderData
    }

    //设置默认数据
    setInformation(seekSpiderData = {}) {
        console.log(seekSpiderData)
        this.state.seekSpiderInformation['findVideo'] = seekSpiderData[seekSpider.findVideoKey] || '';//设置视频
        this.setState({})
    }

    checkInfor() {
        console.log(this.getInformation())
    }
}